import { h } from "@stencil/core";
export class Headline {
    constructor() {
        this.href = undefined;
        this.target = "_self";
        this.variant = "primary";
        this.download = false;
    }
    render() {
        return (h("a", { key: '03b2bef7af128363e3b54bd25e9569690bc98266', href: this.href, target: this.target }, h("slot", { key: '22d08475290fda21ad3bab36dde7c718bd7571fa' })));
    }
    static get is() { return "ux-link"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["link.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["link.css"]
        };
    }
    static get properties() {
        return {
            "href": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The href of the link"
                },
                "attribute": "href",
                "reflect": false
            },
            "target": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"_self\" | \"_blank\"",
                    "resolved": "\"_blank\" | \"_self\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The target of the link (default is _self)"
                },
                "attribute": "target",
                "reflect": false,
                "defaultValue": "\"_self\""
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"primary\"",
                    "resolved": "\"primary\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The variant of the link"
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "\"primary\""
            },
            "download": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "false",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The download attribute of the link"
                },
                "attribute": "download",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=link.js.map
